// import docRevsModDefine from "@/document/revisions/mixins/docRevsModDefine.js";
import revs from "@/data/forms/mixins/revs.js";
import describeDocument from "@/data/describe/mixins/describeDocument";
import { mapGetters } from "vuex";

export default {
  data() {
    return {
      valid: true
    };
  },
  mixins: [revs, describeDocument],
  computed: {
    ...mapGetters(["getUser", "getDetailRev", "getDocumentRevMod"])
  },
  methods: {
    generateInitialDocumentRev(tag) {
      // FORM
      let rev = this.formDocumentRevision;

      // REV data
      rev.type = this.defineDocumentFromTag(tag).type;
      rev.sec = this.defineDocumentFromTag(tag).sec;
      rev.stat = this.defineDocumentFromTag(tag).stat;

      // USER updated by / prepared by
      if (this.getUser !== null) {
        rev.uname = this.getUser.basic.title;
        rev.udid = this.getUser.basic.did;
        rev.uemail = this.getUser.basic.email;
      }
      return rev;
    },
    updateDocumentRev() {
      // REV current data
      let rev = this.getDetailRev;

      // MOD define
      let mod = this.getDocumentRevMod.mod;
      let modc = this.getDocumentRevMod.modc; // mod value current
      let modcc = this.getDocumentRevMod.modcc; // comment for last rev mod
      let modm = this.getDocumentRevMod.modm; // comment for max rev mod
      let modmc = this.getDocumentRevMod.modmc; // comment for max rev mod
      let nmod = this.getDocumentRevMod.nmod; // counter
      let nrev = this.getDocumentRevMod.nrev; // counter

      // REV MOD update
      rev.modc = modc; // mod value current
      rev.modcc = modcc; // mod value current
      rev.modm = modm; // mod value maximum
      rev.modmc = modmc; // mod value maximum comment

      // REV Counters
      rev.nmod = nmod + this.getDetailRev.nmod;
      rev.nrev = nrev + this.getDetailRev.nrev;

      // REV MOD user update
      rev.uname = this.getUser.basic.title;
      rev.udid = this.getUser.basic.did;
      rev.uemail = this.getUser.basic.email;

      // REV Update
      if (mod > 0.99 && mod < 1.99) {
        // Transform
        let temp = this.getDetailRev;
        rev.r1 = temp.r1 + 1;
        rev.r2 = 0;
        rev.r3 = 0;
      }
      if (mod > 1.99 && mod < 2.99) {
        // Major
        let temp = this.getDetailRev;
        rev.r1 = temp.r1;
        rev.r2 = temp.r2 + 1;
        rev.r3 = 0;
      }
      if (mod > 2.99) {
        // Minor
        let temp = this.getDetailRev;
        rev.r1 = temp.r1;
        rev.r2 = temp.r2;
        rev.r3 = temp.r3 + 1;
      }

      // HELP
      // console.log("DOC REV");
      // console.log(rev);

      return rev;
    }
  }
};
